module.exports = __webpack_public_path__ + "img/icon-segments.1b04a591.svg";